import NavLink from '../navLink'
import H2Title from '../public/h2Title'

const Yqlj = ({ linkList = [] }) => (
  <div className="w-full pt-[60px] bg-[#E7E7E7] lg:bg-white pb-10 lg:pb-0">
    <div className="flex justify-center items-center">
      <H2Title title="友情链接" />
    </div>
    <hr className="mt-0 lg:mt-5" />
    <div className="mt-0 lg:mt-5">
      {linkList.map(({ name, link }, key) => (
        <NavLink target="_blank" key={key} className="ml-4 font-sourceHan text-[#333333]" to={link}>
          {name}
        </NavLink>
      ))}
    </div>
  </div>
)

export default Yqlj
